export enum GroupAccessMode {
	INVITE_ONLY = 'PRIVATE',
	OPEN = 'OPEN',
}

export interface GroupAccessSettings {
	accessMode: GroupAccessMode;
	professionalsOnly: boolean;
	restrictEmailDomain: boolean;
	emailDomain: string;
	termsOfUse: boolean;
	enableAccessCodes: boolean;
	sharePersonalInformation: boolean;
	paidEntry: boolean;
	joinOnFirstAccess: boolean;
}

export interface GroupAccessCodesRequest {
	accessCodes: string[];
}

export interface GroupAccessCodesListItem {
	accessCode: string,
	status: AccessCodeStatus,
	user: BaseUserInformation,
	lstUpdDt: string,
	crtDt: string,
}

export enum AccessCodeStatus {
	ACTIVATED = "activated",
	AVAILABLE = "available"
}

export interface BaseUserInformation {
	id: string,
	firstName: string,
	lastName: string,
}
